import { Box, Button, Card, CardContent, CardHeader, TextField, Typography, Alert } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import api from "../services/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setMsg(null); setErr(null);
    if (!token) { setErr('Missing or invalid token'); return; }
    if (password !== confirm) { setErr('Passwords do not match'); return; }
    if (password.length < 6) { setErr('Password must be at least 6 characters'); return; }
    setLoading(true);
    try { await api.post('/auth/reset-password', { token, password }); setMsg('Password updated. You can now login.'); }
    catch (e:any){ setErr(e?.response?.data?.message || 'Failed to reset password'); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', px: 3 }}>
      <Card sx={{ maxWidth: 500, width: '100%', borderRadius: 3, boxShadow: 8 }}>
        <CardHeader title={<Typography variant="h5" fontWeight={900}>Set New Password</Typography>} />
        <CardContent>
          {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}
          {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
          <form onSubmit={submit} className="space-y-4">
            <TextField label="New Password" type="password" fullWidth required value={password} onChange={(e)=>setPassword(e.target.value)} />
            <TextField label="Confirm Password" type="password" fullWidth required value={confirm} onChange={(e)=>setConfirm(e.target.value)} />
            <Button type="submit" variant="contained" disabled={loading || !token} fullWidth>Update Password</Button>
          </form>
          <Typography variant="body2" sx={{ mt: 2 }}>Back to <a href="/login" className="text-blue-700 hover:underline">Login</a></Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

